import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import { getParcelsList } from '@/parcels/pages/ParcelsPage/pages/ParcelsListPage/helpers'

const InfoParcelsText = ({ selectedParcels }) => {
  const { t } = useTranslation()

  return (
    <>
      <Text type="bodyMRegular">
        {selectedParcels?.length > 1
          ? t('Estás a punto de preparar los envíos')
          : t('Estás a punto de preparar el envío')}{' '}
        <Text type="bodyMBold" tag="span">
          {getParcelsList(
            selectedParcels?.map(parcel => parcel.order?.name),
            t
          )}
        </Text>
        .
      </Text>
      <Text type="bodyMRegular">
        {t('Se generará una etiqueta individual para cada envío y sus productos se marcarán como empaquetados.')}
      </Text>
    </>
  )
}

export default InfoParcelsText
